export const SUPPORTED_SUBDOMAIN_LANGS = ['de', 'en', 'es', 'fr', 'it', 'pl', 'pt', 'ru', 'zh'];

export const getLangSubdomain = (): string | undefined => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length >= 2 && SUPPORTED_SUBDOMAIN_LANGS.includes(parts[0])) {
    return parts[0];
  }
  return undefined;
};
